'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _MOBILE = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

var getScratchCanvas = function getScratchCanvas() {
    return document.createElement('CANVAS');
};

var getScratchContext = function getScratchContext() {
    var scratchCanvas = document.createElement('CANVAS');
    return scratchCanvas.getContext('2d');
};

var getMouseX = exports.getMouseX = function getMouseX(evt) {
    if ('offsetX' in evt) {
        return evt.offsetX;
    } else if ('nativeEvent' in evt && 'offsetX' in evt.nativeEvent) {
        return evt.nativeEvent.offsetX;
    }
    var target = evt.target || evt.srcElement;
    var style = target.currentStyle || window.getComputedStyle(target, null);
    var rect = target.getBoundingClientRect();
    return evt.clientX - style.borderLeftWidth - rect.left;
};

var getMouseY = exports.getMouseY = function getMouseY(evt) {
    if ('offsetY' in evt) {
        return evt.offsetY;
    } else if ('nativeEvent' in evt && 'offsetY' in evt.nativeEvent) {
        return evt.nativeEvent.offsetY;
    }
    var target = evt.target || evt.srcElement;
    var style = target.currentStyle || window.getComputedStyle(target, null);
    var rect = target.getBoundingClientRect();
    return evt.clientX - style.borderTopWidth - rect.left;
};

var extractImageData = exports.extractImageData = function extractImageData(imageSrc, maxWidth, maxHeight, scale, onSuccess) {
    var onError = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

    var canvas = getScratchCanvas();
    canvas.width = maxWidth;
    canvas.height = maxHeight;
    var image = new Image();
    image.crossOrigin = 'use-credentials';
    if (onError) {
        image.onerror = function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return onError.apply(undefined, [imageSrc].concat(args));
        };
    }
    if (!scale) {
        scale = 1;
    }
    image.onload = function () {
        var scratchContext = canvas.getContext('2d');
        scratchContext.setTransform(scale, 0, 0, scale, 0, 0);
        scratchContext.drawImage(image, 0, 0);
        var imageData = scratchContext.getImageData(0, 0, maxWidth * scale, maxHeight * scale);
        onSuccess(imageData);
    };
    image.src = imageSrc;
};

var extractImageDataPromise = exports.extractImageDataPromise = function extractImageDataPromise(imageSrc, maxWidth, maxHeight) {
    var scale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    return new Promise(function (resolve, error) {
        extractImageData(imageSrc, maxWidth, maxHeight, scale, resolve, error);
    });
};

var saveCanvasImageAs = exports.saveCanvasImageAs = function saveCanvasImageAs(canvas, filename) {
    var mimeType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'image/png';

    var link = document.createElement('a');
    canvas.toBlob(function (blob) {
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        requestAnimationFrame(function () {
            URL.revokeObjectURL(link.href);
            link.href = null;
        });
    }, mimeType);
};

var printCanvasImage = exports.printCanvasImage = function printCanvasImage(canvas) {
    var content = '<!DOCTYPE html><html><head><title></title></head><body onload="window.focus(); window.print(); window.close();"><img src="' + canvas.toDataURL('image/png') + '"/></body></html>';
    var printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(content);
    printWindow.document.close();
    printWindow.focus();
};

var imageData2canvas = function imageData2canvas(imageData) {
    var canvas = getScratchCanvas();
    canvas.width = imageData.width;
    canvas.height = imageData.height;
    var scratchContext = canvas.getContext('2d');
    scratchContext.putImageData(imageData, 0, 0);
    return canvas;
};

var saveImageDataAs = exports.saveImageDataAs = function saveImageDataAs(imageData, filename) {
    var mimeType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'image/png';

    saveCanvasImageAs(imageData2canvas(imageData), filename, mimeType);
};

var printImageData = exports.printImageData = function printImageData(imageData) {
    printCanvasImage(imageData2canvas(imageData));
};

var createImageData = exports.createImageData = function createImageData() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
    }

    if (typeof window.ImageData === 'function') {
        return new (Function.prototype.bind.apply(window.ImageData, [null].concat(args)))();
    }
    var i = 0;
    var data = void 0;
    if (args[0] instanceof Uint8ClampedArray) {
        data = args[i++];
    }
    var width = args[i++];
    var height = args[i];

    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext('2d');
    var imageData = ctx.createImageData(width, height);
    if (data) imageData.data.set(data);
    return imageData;
};

var resizeImageData = exports.resizeImageData = function resizeImageData(imageData, newWidth, newHeight) {
    var imageCanvas = imageData2canvas(imageData);
    var context = getScratchContext();
    var canvas = context.canvas;
    canvas.width = newWidth;
    canvas.height = newHeight;
    context.webkitImageSmoothingEnabled = true;
    context.mozImageSmoothingEnabled = true;
    context.imageSmoothingEnabled = true;
    context.drawImage(imageCanvas, 0, 0, newWidth, newHeight);
    return context.getImageData(0, 0, newWidth, newHeight);
};

// https://github.com/facebook/react/issues/14856
// https://developers.google.com/web/updates/2019/02/scrolling-intervention
var fixChromePassiveEventListeners = exports.fixChromePassiveEventListeners = function fixChromePassiveEventListeners() {
    var EVENTS_TO_MODIFY = ['touchstart', 'touchmove', 'touchend', 'touchcancel', 'wheel'];

    var originalAddEventListener = document.addEventListener.bind();
    document.addEventListener = function (type, listener, options, wantsUntrusted) {
        var modOptions = options;
        if (EVENTS_TO_MODIFY.includes(type)) {
            if (typeof options === 'boolean') {
                modOptions = {
                    capture: options,
                    passive: false
                };
            } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
                modOptions = _extends({}, options, {
                    passive: false
                });
            }
        }

        return originalAddEventListener(type, listener, modOptions, wantsUntrusted);
    };

    var originalRemoveEventListener = document.removeEventListener.bind();
    document.removeEventListener = function (type, listener, options) {
        var modOptions = options;
        if (EVENTS_TO_MODIFY.includes(type)) {
            if (typeof options === 'boolean') {
                modOptions = {
                    capture: options,
                    passive: false
                };
            } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
                modOptions = _extends({}, options, {
                    passive: false
                });
            }
        }
        return originalRemoveEventListener(type, listener, modOptions);
    };
};


//////////////////
// WEBPACK FOOTER
// ../rc-canvas/lib/Utils.js
// module id = 89
// module chunks = 0